var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.129,9.943a3.981,3.981,0,1,0-3.981-3.98A3.985,3.985,0,0,0,15.129,9.943Zm0-6.461a2.481,2.481,0,1,1-2.481,2.481A2.484,2.484,0,0,1,15.129,3.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.449,10.886,17.92,10.7a.75.75,0,0,0-.492,1.418l.495.171a3.662,3.662,0,0,1,2.585,3.763L20.5,20.541H9.745l.005-4.493A3.646,3.646,0,0,1,12.3,12.3l.529-.184a.75.75,0,1,0-.493-1.416l-.561.2A5.128,5.128,0,0,0,8.25,16.055L8.244,21.29a.749.749,0,0,0,.75.751H21.251a.75.75,0,0,0,.75-.75l.007-5.228A5.143,5.143,0,0,0,18.449,10.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.756,10.643a2.9,2.9,0,1,0-2.9-2.9A2.9,2.9,0,0,0,6.756,10.643Zm0-4.3a1.4,1.4,0,1,1-1.4,1.4A1.4,1.4,0,0,1,6.756,6.348Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.479,18.541H3.5l.006-3.6A2.166,2.166,0,0,1,5,12.7l.345-.122a.75.75,0,1,0-.5-1.414l-.378.135a3.679,3.679,0,0,0-2.46,3.658L2,19.29a.749.749,0,0,0,.75.751h3.73a.75.75,0,0,0,0-1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.2caafc1adeb233ff8991ebdb3c92acb4.svg";
export { ForwardRef as ReactComponent };